import $ from "jquery";
import "slick-carousel";
import { debounce } from "../utils/debounce.js";

const sliderHeaderUsps = () => {
  const el = {
    target:
      ".js-slider-usp .elementor-widget-container ul.elementor-icon-list-items",
  };

  let $carousel = $();

  const slickOption = {
    infinite: true,
    autoplay: true,
    arrows: false,
    slidesToShow: 3,
    autoplaySpeed: 7000,
    cssEase: "linear",
    speed: 10000,
    variableWidth: false,
    pauseOnFocus: false, // Add this to prevent pausing on focus
    pauseOnHover: false, // Add this to prevent pausing on hover
    waitForAnimate: false, // Add this to prevent waiting for animation to complete
    touchThreshold: 10, // Add this to make touch response more sensitive
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 1177,
        settings: "unslick",
      },
      {
        breakpoint: 874,
        settings: {
          slidesToShow: 5,
          speed: 7000,
        },
      },
      {
        breakpoint: 601,
        settings: {
          slidesToShow: 4,
          speed: 14000,
        },
      },
    ],
  };

  const init = () => {
    $(window).on("load", function () {
      $carousel = $(el.target);

      // Initial setup
      if ($(window).outerWidth() < 1177) {
        exec();
      }

      // Handle visibility change
      document.addEventListener("visibilitychange", function () {
        if (!document.hidden && $carousel.hasClass("slick-initialized")) {
          $carousel.slick("slickPlay");
        }
      });

      // Handle resize
      $(window).on(
        "resize",
        debounce(function () {
          if ($(window).outerWidth() < 1177) {
            if (!$carousel.hasClass("slick-initialized")) {
              exec();
            } else {
              $carousel.slick("setPosition"); // Add this to recalculate positions
              $carousel.slick("slickPlay");
            }
          }
        }, 100)
      );
    });
  };

  const exec = () => {
    $carousel.slick(slickOption);
  };

  init();
};

try {
  sliderHeaderUsps();
} catch (error) {
  console.error(error);
}
